export default "__VITE_ASSET__CTWOq$Ls__"